import axios from "axios";
import { BASE_URL } from "../../constant/staticUrl";
import axiosInstance from "../../utils/axiosInstance";
const API = axios.create({ baseURL: BASE_URL });

export const createMentorApi = (formData) =>
  axiosInstance.post("/mentor/create", formData);

export const getMentorListApi = (formData) =>
  axiosInstance.get("/mentor/get-all", formData);

export const updateMentorApi = (id, formData) =>
  axiosInstance.update(`/mentor/update/${id}`, formData);

export const deleteMentorApi = (id, formData) =>
  axiosInstance.delete(`/mentor/delete/${id}`, formData);

